import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Toaster as SonnerToaster } from "@/components/ui/sonner";
import AdminRoutes from "@/modules/admin/AdminRoutes";

/**
 * Admin Panel — standalone entry point.
 *
 * AdminRoutes defines its own paths ("/", "/login", "/tenants", ...) and its
 * own AdminAuthProvider (separate `admin_token` in localStorage, separate
 * JWT signed by the Admin Panel backend). Nothing here is shared with the
 * CRM app. Both Toasters are mounted here because admin pages call
 * `toast.*` from both react-hot-toast and sonner depending on which page
 * was authored with which library.
 */
function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <SonnerToaster richColors position="top-right" />
      <AdminRoutes />
    </BrowserRouter>
  );
}

export default App;
